export const IMAGE_WIDTHS = [100, 480, 720, 1280, 1920];
